import { render, staticRenderFns } from "./ticketsPackage.vue?vue&type=template&id=6a8de4a0&"
import script from "./ticketsPackage.vue?vue&type=script&lang=js&"
export * from "./ticketsPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports